import React, { useState, useEffect } from 'react';
import { Input, Button, Form } from 'antd';
import { ArrowLeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Balance from '../../../../../assets/Balance.jsx';
import BankTransfer from '../component/BankTransfer.jsx';

import Crypto from '../component/Crypto.jsx';
import Paypal from '../component/Paypal.jsx';
import UPI from '../component/UPI.jsx';
import Match2Pay from '../component/Match2Pay.jsx';
import Cregis from '../component/Cregis.jsx';
import CashWithdraw from '../component/CashWithdraw.jsx';
import UniPayment from '../component/UniPayment.jsx';
// import { GetTermsByTermsApi } from '../../../../../api/request/common.js';


const PaymentDetails = ({ paymentMethod, resetAll, onBack, walletBalance }) => {
    const [form] = Form.useForm();
    const [withdrawAmount, setWithdrawAmount] = useState();
    const [validation, setValidation] = useState('');
    const [tncFileUrl, setTncFileUrl] = useState('');

    const handleAmountChange = (e) => {
        const value = parseFloat(e.target.value) || 0;
        setWithdrawAmount(value);
    };

    console.log("paymentMethod--", paymentMethod)
    const renderStep = () => {
        switch (paymentMethod?.title) {
            case "Wire Transfer":
                return <BankTransfer amount={withdrawAmount} paymentGatewayId={paymentMethod?.id} resetAll={resetAll} details={paymentMethod?.details} validateAmount={validation} tncFileUrl={tncFileUrl} />;
            case "Cash":
                return <CashWithdraw amount={withdrawAmount} paymentGatewayId={paymentMethod?.id} resetAll={resetAll} validateAmount={validation} tncFileUrl={tncFileUrl} />;
            case "Crypto":
                return <Crypto amount={withdrawAmount} resetAll={resetAll} validateAmount={validation} tncFileUrl={tncFileUrl} />;
            case "Paypal":
                return <Paypal amount={withdrawAmount} resetAll={resetAll} validateAmount={validation} tncFileUrl={tncFileUrl} />;
            case "UPI":
                return <UPI amount={withdrawAmount} resetAll={resetAll} validateAmount={validation} tncFileUrl={tncFileUrl} />;
            case "Match2Pay":
                return <Match2Pay amount={withdrawAmount} resetAll={resetAll} paymentGatewayId={paymentMethod?.id} validateAmount={validation}/>;
            case "Cregis":
                return <Cregis amount={withdrawAmount} resetAll={resetAll} paymentGatewayId={paymentMethod?.id} methodValue={paymentMethod?.methodValue} validateAmount={validation}/>;
            case "Unipayment":
                return <UniPayment amount={withdrawAmount} resetAll={resetAll} paymentGatewayId={paymentMethod?.id} validateAmount={validation}/>;
            default:
                return null;
        }
    }

    const validateAmount = (_, value) => {
        const numericValue = parseFloat(value);
        const min = parseFloat(paymentMethod?.minAmount?.replace(/[^0-9.]/g, ""));
        const max = parseFloat(paymentMethod?.maxAmount?.replace(/[^0-9.]/g, ""));

        if (!value) {
            setValidation('Please deposit enter amount');
            return Promise.reject("Please enter deposit amount");
        }
        if (isNaN(numericValue)) {
            setValidation('Please enter valid number');
            return Promise.reject("Please enter valid number");
        }
        if (numericValue < min) {
            setValidation(`Minimum withdrawal is ${paymentMethod.minAmount}`);
            return Promise.reject(`Minimum withdrawal is ${paymentMethod.minAmount}`);
        }
        if (numericValue > max) {
            setValidation(`Maximum withdrawal is ${paymentMethod.maxAmount}`);
            return Promise.reject(`Maximum withdrawal is ${paymentMethod.maxAmount}`);
        }
        setValidation('');
        return Promise.resolve();
    }
    // const fetchTncFileUrl = async () => {
    //     try {
    //         const { data } = await GetTermsByTermsApi(2);
    //         if (data?.success && data?.data?.fileURL) {
    //             setTncFileUrl(data.data.fileURL);
    //         }
    //     } catch (err) { }
    // }

    // useEffect(() => {
    //     fetchTncFileUrl();
    // }, []);


    return (
        <div className="w-full p-6 border-2 border-light rounded-md mt-3">
            {/* Header */}
            <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                    <Button
                        type="text"
                        icon={<ArrowLeftOutlined />}
                        onClick={onBack}
                        className="text-gray-600"
                    />
                    <h1 className="text-xl font-semibold text-gray-800">Withdrawal Details</h1>
                </div>
                <div className="text-primary px-4 py-1 rounded-lg font-medium flex items-center border border-primary">
                    <div>
                        {paymentMethod?.icon}
                    </div>
                    <div className='ms-2'>
                        {paymentMethod?.label}
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                {/* Left Column - Withdrawal Form */}
                <div className="lg:col-span-2">
                    <div className="space-y-6">
                        {/* Withdrawal Amount */}
                        <div className="bg-white rounded-lg border p-6">
                            {paymentMethod?.title !== "Unipayment" && (
                                <div className="grid md:grid-cols-2 gap-5">
                                    <Form form={form} >
                                        <div className="mb-4">
                                            <label className="text-lg font-medium text-gray-700 block mb-2">Withdrawal Amount</label>
                                            <Form.Item name="withdrawAmount" rules={[{ validator: validateAmount }]}>
                                                <Input
                                                    size="large"
                                                    prefix="$"
                                                    placeholder="0.00"
                                                    className="text-lg"
                                                    value={withdrawAmount}
                                                    onChange={handleAmountChange}
                                                    type="number"
                                                />
                                            </Form.Item>
                                        </div>
                                    </Form>

                                    {/* Wallet Info Display */}
                                    <div className="mb-4">
                                        <label className="text-lg font-medium text-gray-700 block mb-2">Withdrawing From</label>
                                        <div className="flex items-center gap-3 py-2 px-4 bg-gray-50 rounded-lg border">
                                            <Balance color="var(--sidebarColor)" className="size-6" />
                                            <div className="flex items-center">
                                                <span className="text-base font-medium">Wallet</span>
                                                <span className="text-sm text-gray-500 ms-2">${walletBalance || 0}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className={paymentMethod?.title !== "Unipayment" ? "bg-white rounded-lg mt-5" : ""}>
                                {renderStep()}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Column - Transaction Summary */}
                <div className="lg:col-span-1 ">
                    <div className="bg-white rounded-lg border p-6 h-full justify-between">
                        <div>
                            <h2 className="text-xl font-semibold text-gray-800 mb-6">Transaction Summary</h2>
                            <div className="space-y-4">
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Withdrawal Amount:</span>
                                    <span className="font-semibold">$ {withdrawAmount?.toFixed(2) || 0.00}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Processing Fee:</span>
                                    <span className="font-semibold">{paymentMethod?.fee || 0.00}</span>
                                </div>
                                <hr className="border-gray-200" />
                                <div className="flex justify-between text-lg">
                                    <span className="font-semibold">Total Amount:</span>
                                    <span className="font-bold text-green-600">$ {withdrawAmount?.toFixed(2) || 0.00}</span>
                                </div>
                            </div>
                        </div>
                        {/* Important Information */}
                        <div className="bg-blue-50 rounded-lg p-4 mt-4">
                            <div className="flex items-start gap-2 mb-3">
                                <InfoCircleOutlined className="text-blue-600 mt-1" />
                                <h3 className="font-semibold text-blue-800">Important Information</h3>
                            </div>
                            <ul className="text-sm text-blue-700 space-y-2">
                                <li>• Processing time: {paymentMethod?.processingTime}</li>
                                <li>• All transactions are encrypted with SSL technology</li>
                                <li>• Withdrawal fees may apply based on payment method</li>
                                <li>• Minimum withdrawal: {paymentMethod?.minAmount}</li>
                                <li>• Maximum withdrawal: {paymentMethod?.maxAmount}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentDetails;